import {widthMinGrid} from 'styles/variables-breakpoints.scss'

const containerQueryConfig = {
  canShowGridView: {
    minWidth: widthMinGrid,
  },
}

export default containerQueryConfig
